<template>
	<div class="category-top">
		<SelectListTab v-model="selectedTab" :tabList="tabList" type="large" />
		<section v-if="selectedTab === '0티어관리'">
			<form
				class="category-top category-top__add"
				@submit.prevent="checkCategory"
			>
				<table class="simple-table">
					<thead>
						<tr>
							<th>티어</th>
							<th>카테고리 설정</th>
							<th>기간</th>
							<th>추가</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="category-top__tier">0</td>
							<td class="category-top__selector">
								<CategorySelector
									class="category-top__selector"
									@change="categoryData($event)"
									:reset="reset"
								/>
							</td>
							<td>
								<DateRange v-model="zeroTierDate" />
							</td>
							<td class="category-top__button">
								<button
									type="submit"
									class="btn blue"
									v-text="'등록'"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</form>
		</section>
		<p class="category-top__time" v-if="selectedTab !== '0티어관리'">
			최근 생성일자 : {{ makeTime }}
		</p>
		<section class="section__table">
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="(item, index) in getTableHead" :key="index">
							{{ item }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(top, index) in categoryTopView"
						:key="index"
						:class="{
							'category-top__tier-zero':
								selectedTab === '메인' && top.tier === 0,
						}"
					>
						<td>{{ top.tier }}</td>
						<td class="category-top__id">
							{{ top.idSecondCategory || '-' }}
						</td>
						<td class="category-top__name">
							{{ top.secondCategoryName || '-' }}
						</td>
						<td class="category-top__id">
							{{ top.idThirdCategory || '-' }}
						</td>
						<td class="category-top__name">
							{{ top.thirdCategoryName || '-' }}
						</td>
						<template v-if="selectedTab === '메인'">
							<td class="category-top__date">
								{{
									top.tier === 0
										? `${top.startAt || '-'}`
										: '-'
								}}
							</td>
							<td class="category-top__date">
								{{
									top.tier === 0 ? `${top.endAt || '-'}` : '-'
								}}
							</td>
						</template>
						<td
							class="category-top__date"
							v-if="selectedTab === '0티어관리'"
						>
							<form
								:id="`${top.idSecondCategory}${top.idThirdCategory}`"
								@submit.prevent="modify(index)"
							>
								<DateRange
									v-model="top.dateRange"
									ref="dateRange"
									class="category-top__range"
								/>
							</form>
						</td>
						<td v-if="selectedTab !== '0티어관리'">
							{{ top.count || '-' }}
						</td>
						<td v-if="selectedTab === '0티어관리'">
							<button
								:form="`${top.idSecondCategory}${top.idThirdCategory}`"
								type="submit"
								class="btn blue"
								v-text="'수정'"
							/>
						</td>
						<td v-if="selectedTab === '0티어관리'">
							<button @click="expiration(top.id)" class="btn red">
								만료
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<table
				class="table-main category-top__percent"
				v-if="selectedTab === '메인'"
			>
				<thead>
					<tr>
						<th>티어</th>
						<th>비율(%)</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="tier in tierWeight" :key="tier.tier">
						<td>{{ tier.tier }}</td>
						<td>{{ tier.weightRate }}</td>
					</tr>
				</tbody>
			</table>
		</section>
	</div>
</template>
<script>
	import SelectListTab from '@/components/common/SelectListTab';
	import CategorySelector from '@/components/common/CategorySelector.vue';
	import DateRange from '@/components/DateRange';
	import moment from 'moment';

	export default {
		data() {
			return {
				selectedTab: '메인',
				tabList: ['메인', '0티어관리', '어워드'],
				tierWeight: [],
				categoryTopView: [],
				categoryList: {},
				addLevel: '',
				addCategoryId: '',
				reset: false,
				zeroTierDate: { from: '', to: '' },
				duplicationData: '',
				makeTime: '',
			};
		},
		components: {
			SelectListTab,
			CategorySelector,
			DateRange,
		},
		watch: {
			selectedTab() {
				this.getData();
			},
		},
		computed: {
			getTabType() {
				if (this.selectedTab === '메인') return 'main';
				if (this.selectedTab === '0티어관리') return 'history';
				if (this.selectedTab === '어워드') return 'award';
			},
			getTableHead() {
				const baseTableHead = [
					'티어',
					'2차 Id',
					'2차 카테고리명',
					'3차 Id',
					'3차 카테고리명',
					'시작일',
					'종료일',
					'조회수',
				];
				if (this.getTabType === 'history') {
					return [
						'티어',
						'2차 Id',
						'2차 카테고리명',
						'3차 Id',
						'3차 카테고리명',
						'기간',
						'수정',
						'강제만료',
					];
				}
				if (this.getTabType === 'award') {
					return [
						'티어',
						'2차 Id',
						'2차 카테고리명',
						'3차 Id',
						'3차 카테고리명',
						'조회수',
					];
				}
				return baseTableHead;
			},
		},
		created() {
			this.getData();
		},
		methods: {
			init() {
				this.reset = true;
				this.zeroTierDate.to = '';
				this.zeroTierDate.from = '';
			},
			async getData() {
				try {
					this.$store.commit('toggleSpinner', true);
					const {
						data: {
							tier_weight,
							category_top_views,
							last_execute_time,
						},
					} = await this.$axiosAdmin2.get(
						`/v3/api/category/top-views?type=${this.getTabType}`
					);
					this.tierWeight = this.selectedTab === '메인' && [
						...tier_weight,
					];
					this.categoryTopView = [...category_top_views];
					this.makeTime = moment
						.unix(last_execute_time)
						.format('YYYY-MM-DD HH:mm');
					this.categoryTopView.forEach(item => {
						item.startAt =
							item.startAt &&
							moment
								.unix(item?.startAt)
								.format('YYYY-MM-DD HH:mm');
						item.endAt =
							item.endAt &&
							moment.unix(item?.endAt).format('YYYY-MM-DD HH:mm');
						item.dateRange = { from: item.startAt, to: item.endAt };
					});
					this.$store.commit('toggleSpinner', false);
				} catch (err) {
					console.error(err);
				}
			},
			categoryData(category) {
				this.categoryList = category;
			},
			async addCategory(params, type) {
				try {
					await this.$axiosAdmin2.post(
						'/v3/api/category/top-views',
						params
					);
					alert(`${type === 'add' ? '등록' : '수정'}되었습니다`);
					this.getData();
					this.init();
				} catch (error) {
					console.error(err);
					alert(
						`${type === 'add' ? '등록' : '수정'}에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요.`
					);
				}
			},

			async checkCategory() {
				if (!this.categoryList.category1)
					return alert('카테고리를 입력해주세요.');
				if (this.categoryList.category2 === null)
					return alert('2차카테고리부터 등록이 가능합니다.');
				if (!this.zeroTierDate.from)
					return alert('시작일을 입력해주세요');
				if (!this.zeroTierDate.to)
					return alert('종료일을 입력해주세요');
				if (
					moment(this.zeroTierDate.from).valueOf() >
					moment(this.zeroTierDate.to).valueOf()
				)
					return alert('종료일이 시작일보다 빠릅니다.');

				if (
					this.categoryList.category2 &&
					!this.categoryList.category3
				) {
					this.addLevel = 2;
					this.addCategoryId = this.categoryList.category2;
				} else {
					this.addLevel = 3;
					this.addCategoryId = this.categoryList.category3;
				}

				try {
					const params = {
						type: 'main',
						level: this.addLevel,
						categoryId: this.addCategoryId,
						tier: 0,
						startAt: moment(this.zeroTierDate.from).valueOf(),
						endAt: moment(this.zeroTierDate.to).valueOf(),
					};
					const { data } = await this.$axiosAdmin2.post(
						'/v3/api/category/top-views/has-top-view',
						params
					);
					const checkData = data.map(item => {
						const tier = String(item.tier);
						const name = item.idSecondCategory
							? `2차 : ${item.secondCategoryName}`
							: item.idThirdCategory
								? `3차 : ${item.thirdCategoryName}`
								: '';
						return `[${tier}티어 - ${name}]`;
					});

					if (checkData.length > 0) {
						this.duplicationData = `삭제 데이터는\n${checkData.join(', ')} 입니다.`;
					} else {
						this.duplicationData = '삭제 데이터는 없습니다.';
					}

					if (!confirm(`${this.duplicationData}\n등록하시겠습니까?`))
						return;

					this.addCategory(params, 'add');
				} catch (err) {
					console.error(err);
				}
			},
			async modify(index) {
				const { dateRange, idSecondCategory, idThirdCategory, id } =
					this.categoryTopView[index];
				const { from, to } = dateRange;

				const startAt = moment(from).valueOf();
				const endAt = moment(to).valueOf();
				if (startAt > endAt) {
					alert('종료일이 시작일보다 빠릅니다.');
					return;
				}

				const level = idSecondCategory && idThirdCategory ? 3 : 2;
				const categoryId =
					idSecondCategory && idThirdCategory
						? idThirdCategory
						: idSecondCategory;

				const params = {
					id,
					type: 'main',
					level,
					categoryId,
					tier: 0,
					startAt,
					endAt,
				};

				this.addCategory(params, 'modify');
			},
			async expiration(id) {
				try {
					await this.$axiosAdmin2.put(
						`/v3/api/category/top-views/expire/${id}`
					);
					alert(
						'강제만료처리되어 종료시간이 현재시간으로 변경되었습니다. 더이상 0티어 노출되지 않습니다.'
					);
					this.getData();
				} catch (err) {
					console.error(err);
					alert(
						'만료에 실패하였습니다. 계속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.category-top {
		&__time {
			margin-top: 20px;
		}
		&__add {
			display: flex;
			flex-direction: column;
			justify-content: center;
			margin: 10px auto 0;
			max-width: 1200px;
			.simple-table {
				th {
					text-align: center;
					background: linear-gradient(
						to top,
						#d3e1f1,
						#f4f7fa,
						#f4f7fa
					);
					border: solid 1px #d5dde6;
					padding-left: 0;
				}
				td {
					text-align: center;
				}
			}
		}
		&__tier-zero {
			background-color: #e9eff8;
		}
		&__selector {
			justify-content: center;
		}
		&__tier {
			width: 100px;
		}
		&__id {
			width: 80px;
		}
		&__name,
		&__date {
			width: 600px;
			margin: 0 auto;
			text-align: center;
		}

		&__range {
			margin: 0 auto;
			justify-content: center;
		}

		&__button {
			width: 100px;
		}
		.section__table {
			margin-top: 20px;
			display: flex;
			gap: 50px;
			.category-top__percent {
				flex-shrink: 7;
				height: 300px;
			}
		}
	}
</style>
